<template>
    <ContainerWithMenu>
        <div class="page-content">
            <div class="margin-bottom-20">
                <h1 class="h2 margin-bottom-20">{{ $t('views.account.title') }}</h1>
            </div>
            <table class="table">
                <tbody>
                    <tr>
                        <td>{{ $t('common.first_name') }}</td>
                        <td>{{user.first_name}}</td>
                        <td class="text-right">
                            <a href="" class="btn btn-default hide">
                                <i class="las la-edit"></i>
                                {{ $t('common.edit') }}
                            </a>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ $t('common.last_name') }}</td>
                        <td>{{user.last_name}}</td>
                        <td class="text-right">
                            <a href="" class="btn btn-default hide">
                                <i class="las la-edit"></i>
                                {{ $t('common.edit') }}
                            </a>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ $t('common.email') }}</td>
                        <td>{{user.email}}</td>
                        <td class="text-right">
                            <a href="" class="btn btn-default hide">
                                <i class="las la-edit"></i>
                                {{ $t('common.edit') }}
                            </a>
                        </td>
                    </tr>
                    <tr class="hide">
                        <td>{{ $t('views.account.biography') }}</td>
                        <td>-</td>
                        <td class="text-right">
                            <a href="" class="btn btn-default hide">
                                <i class="las la-edit"></i>
                                {{ $t('common.edit') }}
                            </a>
                        </td>
                    </tr>
                    <tr class="hide">
                        <td>{{ $t('views.account.profile_picture') }}</td>
                        <td>-</td>
                        <td class="text-right" >
                            <a href="" class="btn btn-default hide">
                                <i class="las la-edit"></i>
                                {{ $t('common.edit') }}
                            </a>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ $t('views.account.language') }}</td>
                        <td>{{getStringLanguage(user.language)}}</td>
                        <td class="text-right">
                            <a href="" class="btn btn-default hide">
                                <i class="las la-edit"></i>
                                {{ $t('common.edit') }}
                            </a>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ $t('views.account.timezone') }}</td>
                        <td>{{user.timezone}}</td>
                        <td class="text-right">
                            <a href="" class="btn btn-default hide">
                                <i class="las la-edit"></i>
                                {{ $t('common.edit') }}
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <SpinnerLoader v-show="loading"></SpinnerLoader>
    </ContainerWithMenu>
</template>

<script>
    import ContainerWithMenu from "../components/container/ContainerWithMenu";
    import {StorageHelper} from "../common/storageHelper";
    import {getClientAdminInfo} from "../api";
    import SpinnerLoader from "../components/common/SpinnerLoader";
    import i18n from '../i18n'
    import {Utils} from "../common/utils";

    export default {
        title: i18n.t('views.account.title'),
        name: "Account",
        components: { ContainerWithMenu, SpinnerLoader },
        data: () => {
            return {
                user: {},
                loading:false
            }
        },
        async mounted() {
            this.loading = true;
            this.errorMessage = "";
            try {
                /** User info got by token saved in storage helper*/
                const responseUser = await getClientAdminInfo();
                this.user = responseUser;
                StorageHelper.setUser(responseUser);
                /** User must be handler for use manage section */
                this.loading = false;
            } catch (e) {
                this.loading = false;

            }
        },
        methods: {
            getStringLanguage(lang) {
                return Utils.getStringLanguage(lang);
            }
        }
    };
</script>
